import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-center mt-10" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "fs-lg-3x fs-sm-1 mb-5 text-center" }, " Step into Saving, Explore Deals, Enjoy Rewards! ")
], -1)
const _hoisted_2 = { class: "dashboard-container mt-10" }
const _hoisted_3 = { class: "d-flex flex-column mb-10 min-h-300" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", {
  class: "",
  style: {}
}, [
  /*#__PURE__*/_createElementVNode("strong", { class: "fs-1 content-header" }, "Upcoming Draws")
], -1)
const _hoisted_5 = { class: "row d-flex flex-row flex-wrap mt-5" }
const _hoisted_6 = {
  class: "d-flex flex-column mb-10",
  style: {"min-height":"300px"}
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", {
  class: "",
  style: {}
}, [
  /*#__PURE__*/_createElementVNode("strong", { class: "fs-1 content-header" }, "Previous Draws")
], -1)
const _hoisted_8 = { class: "row d-flex flex-row flex-wrap mt-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderImage = _resolveComponent("HeaderImage")!
  const _component_UpcomingDrawCard = _resolveComponent("UpcomingDrawCard")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_DrawLoaderCard = _resolveComponent("DrawLoaderCard")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_PreviousDrawCard = _resolveComponent("PreviousDrawCard")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      class: "d-flex justify-content-center",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleToggleChat && _ctx.handleToggleChat(...args))),
      style: {"cursor":"pointer"}
    }, [
      _createVNode(_component_HeaderImage)
    ]),
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          (!_ctx.loadingUpcomingDraws)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                (_ctx.upcomingDraws.length)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.upcomingDraws, (draw, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: index,
                        class: "col-lg-4 col-md-6 col-sm-12 col-xs-12 p-3 mb-5"
                      }, [
                        _createVNode(_component_UpcomingDrawCard, {
                          class: "draw-card",
                          draw: draw,
                          onJoinDraw: _ctx.handleJoinDraw,
                          user: _ctx.authUser,
                          subscriptionsEntries: _ctx.subscriptionsData,
                          drawEntries: _ctx.userEntries
                        }, null, 8, ["draw", "onJoinDraw", "user", "subscriptionsEntries", "drawEntries"])
                      ]))
                    }), 128))
                  : (_openBlock(), _createBlock(_component_el_empty, {
                      key: 1,
                      description: "No Listed Upcoming Draws"
                    }))
              ], 64))
            : (_openBlock(), _createBlock(_component_DrawLoaderCard, {
                key: 1,
                loading: _ctx.loadingUpcomingDraws,
                showButton: true,
                showTimer: true,
                showTitle: true
              }, null, 8, ["loading"]))
        ])
      ]),
      _createVNode(_component_el_divider),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("div", _hoisted_8, [
          (!_ctx.loadingPreviousDraws)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                (_ctx.previousDraws.length)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.previousDraws, (draw, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: index,
                        class: "col-lg-4 col-md-6 col-sm-12 col-xs-12 p-3 mb-5"
                      }, [
                        _createVNode(_component_PreviousDrawCard, {
                          class: "draw-card",
                          draw: draw
                        }, null, 8, ["draw"])
                      ]))
                    }), 128))
                  : (_openBlock(), _createBlock(_component_el_empty, {
                      key: 1,
                      description: "No Listed Previous Draws"
                    }))
              ], 64))
            : (_openBlock(), _createBlock(_component_DrawLoaderCard, {
                key: 1,
                loading: _ctx.loadingPreviousDraws,
                showButton: false,
                showTimer: false,
                showTitle: true
              }, null, 8, ["loading"]))
        ])
      ])
    ])
  ]))
}